export enum StatusSolicitacaoEnum {
    Nenhum = 0,
    NenhumDescription = 'Nenhum',
    Ativo = 1,
    AtivoDescription = 'Ativo',
    Cancelado = 2,
    CanceladoDescription = 'Cancelado',
}

export namespace StatusSolicitacaoEnum {
    export function values() {
        return Object.keys(StatusSolicitacaoEnum)
            .filter((type) => isNaN(<any>type) && type !== 'values' && !type.includes('Description') && !type.includes('Nenhum'))
            .map(item => {
                return { enum: +StatusSolicitacaoEnum[item], description: (StatusSolicitacaoEnum[item + 'Description']).split(';')[0] };
            });
    }
}
